import React from 'react';
import { Clock, Repeat, AlertCircle, EyeOff, Frown, Battery } from 'lucide-react';
export function CostComparison() {
  const items = [{
    icon: Clock,
    text: 'Horas perdidas buscando proveedores que no responden'
  }, {
    icon: Repeat,
    text: 'Gastar plata en stock que no se vende y queda trabado'
  }, {
    icon: AlertCircle,
    text: 'Ver cómo otros venden mientras vos seguís dudando'
  }, {
    icon: EyeOff,
    text: 'Publicar y que nadie visite tu producto'
  }, {
    icon: Frown,
    text: 'Perder reputación por no saber gestionar un reclamo'
  }, {
    icon: Battery,
    text: 'Seguir en el mismo trabajo sin generar un ingreso extra'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <div className="text-center mb-10 md:mb-14" data-id="element-85">
          <p className="text-red-400 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-86">
            ⚖️ El costo real
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-87">
            ¿Cuánto te cuesta seguir{' '}
            <span className="text-red-400" data-id="element-88">dando vueltas?</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-4 mb-10" data-id="element-89">
          {items.map(({
          icon: Icon,
          text
        }, i) => <div key={i} className="bg-surface border border-zinc-800 rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-90">
              <div className="w-9 h-9 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center shrink-0" data-id="element-91">
                <Icon className="w-4 h-4 text-red-400" data-id="element-92" />
              </div>
              <span className="text-zinc-200 text-sm md:text-base leading-snug pt-1" data-id="element-93">
                {text}
              </span>
            </div>)}
        </div>

        <div className="bg-black/40 border border-primary/30 rounded-2xl p-6 md:p-8 text-center" data-id="element-94">
          <p className="text-base md:text-2xl font-bold text-zinc-300 leading-relaxed" data-id="element-95">
            El próximo mes puede ser igual.
            <br data-id="element-96" />
            <span className="text-primary text-lg md:text-3xl" data-id="element-97">
              O puede ser el primero en el que empieces a generar ventas reales.
            </span>
          </p>
        </div>
      </div>
    </section>;
}